import { render, staticRenderFns } from "./BookDisplayPanel.vue?vue&type=template&id=1043ecdd&scoped=true&"
import script from "./BookDisplayPanel.vue?vue&type=script&lang=js&"
export * from "./BookDisplayPanel.vue?vue&type=script&lang=js&"
import style0 from "./BookDisplayPanel.vue?vue&type=style&index=0&id=1043ecdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1043ecdd",
  null
  
)

export default component.exports